import React from 'react';
import { Typography, Card, Divider } from 'antd';

const { Title, Paragraph, Text } = Typography;

const Terms = () => (
  <div style={{ maxWidth: 800, margin: '20px auto', padding: '0 16px' }}>
    <div style={{ textAlign: 'center', marginBottom: '30px' }}>
      <Title level={2}>用户协议</Title>
      <Text style={{ color: '#666' }}>最后更新时间：2026年6月16日</Text>
    </div>

    <Card>
      <Title level={3}>1. 协议范围</Title>
      <Paragraph>
        本《用户协议》（以下简称"本协议"）是您与漳浦声语文化传媒有限公司（以下简称"我们"或"公司"）之间关于您使用管理师软件服务所订立的协议。
      </Paragraph>
      <Paragraph>
        请您在使用本服务前仔细阅读本协议的全部内容。如果您不同意本协议的任意内容，或者无法准确理解相关条款的含义，请不要进行后续操作。
      </Paragraph>

      <Title level={3}>2. 服务内容</Title>
      <Paragraph>
        管理师软件是一款个人和团队管理系统，提供以下服务：
      </Paragraph>
      <ul>
        <li>文件管理、物品管理、资金管理、时间管理等20个核心功能模块</li>
        <li>数据云端存储和同步服务</li>
        <li>多平台支持（Web端、移动APP、微信小程序）</li>
        <li>会员服务和付费功能</li>
        <li>推荐分享和积分奖励系统</li>
      </ul>

      <Title level={3}>3. 账户注册与安全</Title>
      <Paragraph>
        3.1 您可以通过手机号注册账户，或使用微信一键登录。
      </Paragraph>
      <Paragraph>
        3.2 您应当保证注册信息的真实性、准确性和完整性，并及时更新注册信息。
      </Paragraph>
      <Paragraph>
        3.3 您有责任维护账户和密码的安全，因您保管不善可能导致遭受盗号或密码失窃，责任由您自行承担。
      </Paragraph>
      <Paragraph>
        3.4 您不得将账户转让、出售或以其他方式许可他人使用。
      </Paragraph>

      <Title level={3}>4. 使用规范</Title>
      <Paragraph>
        4.1 您在使用本服务时，应当遵守相关法律法规，不得利用本服务从事违法违规活动。
      </Paragraph>
      <Paragraph>
        4.2 您不得上传、发布、传播含有以下内容的信息：
      </Paragraph>
      <ul>
        <li>违反国家法律法规的信息</li>
        <li>危害国家安全、泄露国家秘密的信息</li>
        <li>煽动民族仇恨、民族歧视的信息</li>
        <li>宣扬邪教和封建迷信的信息</li>
        <li>散布谣言、扰乱社会秩序的信息</li>
        <li>淫秽、色情、赌博、暴力、凶杀、恐怖的信息</li>
        <li>侵犯他人知识产权或其他合法权益的信息</li>
      </ul>

      <Title level={3}>5. 付费服务</Title>
      <Paragraph>
        5.1 本服务提供免费功能和付费功能。付费功能需要购买相应会员服务。
      </Paragraph>
      <Paragraph>
        5.2 会员服务包括：高级会员（98元/年）、VIP会员（198元/年）。
      </Paragraph>
      <Paragraph>
        5.3 会员服务为数字商品，开通后立即生效。除法律规定情形外，已开通的会员服务不支持退款。
      </Paragraph>
      <Paragraph>
        5.4 我们保留调整服务价格的权利，价格调整将在服务页面提前通知。
      </Paragraph>

      <Title level={3}>6. 知识产权</Title>
      <Paragraph>
        6.1 本服务的软件、技术、程序、代码、用户界面、设计、商标、标识等知识产权均归我们所有。
      </Paragraph>
      <Paragraph>
        6.2 您上传的内容，其知识产权归您所有。您授权我们在提供服务所必需的范围内使用您的内容。
      </Paragraph>
      <Paragraph>
        6.3 未经我们书面许可，您不得复制、修改、传播、出售本服务的任何部分。
      </Paragraph>

      <Title level={3}>8. 账号注销</Title>
      <Paragraph>
        8.1 您有权随时申请注销账号。注销方式详见《隐私政策》「账号注销规则」章节。
      </Paragraph>
      <Paragraph>
        8.2 账号注销后，您的个人数据将被删除且无法恢复（法律法规要求保留的除外），会员权益同步终止，已支付费用不予退还（法律另有规定除外）。
      </Paragraph>

      <Title level={3}>9. 隐私保护</Title>
      <Paragraph>
        9.1 我们重视您的隐私保护，具体内容请参见《隐私政策》。
      </Paragraph>
      <Paragraph>
        9.2 我们仅收集为实现服务功能所必需的信息，并采取合理措施保护您的个人信息安全。
      </Paragraph>

      <Title level={3}>10. 服务变更与中止</Title>
      <Paragraph>
        10.1 我们有权根据业务发展需要，对服务内容进行变更、升级或中止。
      </Paragraph>
      <Paragraph>
        10.2 如因不可抗力、技术故障等原因导致服务中断，我们不承担责任。
      </Paragraph>
      <Paragraph>
        10.3 如您违反本协议，我们有权中止或终止向您提供服务。
      </Paragraph>

      <Title level={3}>11. 免责声明</Title>
      <Paragraph>
        11.1 本服务按"现状"提供，我们不保证服务的连续性、稳定性和无错误性。
      </Paragraph>
      <Paragraph>
        11.2 您使用本服务所产生的风险由您自行承担。
      </Paragraph>
      <Paragraph>
        11.3 我们不对因使用本服务而导致的任何直接、间接、偶然、特殊或后果性损害承担责任。
      </Paragraph>

      <Title level={3}>12. 协议修改</Title>
      <Paragraph>
        12.1 我们有权根据需要修改本协议，修改后的协议将在服务页面公布。
      </Paragraph>
      <Paragraph>
        12.2 如您不同意修改后的协议，可以停止使用本服务。
      </Paragraph>
      <Paragraph>
        12.3 如您继续使用本服务，视为同意修改后的协议。
      </Paragraph>

      <Title level={3}>13. 争议解决</Title>
      <Paragraph>
        13.1 本协议的签订、履行和解释均适用中华人民共和国法律。
      </Paragraph>
      <Paragraph>
        13.2 因本协议产生的争议，双方应友好协商解决；协商不成的，可向有管辖权的人民法院提起诉讼。
      </Paragraph>

      <Title level={3}>14. 其他条款</Title>
      <Paragraph>
        14.1 本协议构成双方对本协议之约定事项及其他有关事宜的完整协议。
      </Paragraph>
      <Paragraph>
        14.2 如本协议中的任何条款被认定为无效或不可执行，其余条款仍然有效。
      </Paragraph>
      <Paragraph>
        14.3 本协议的解释权归漳浦声语文化传媒有限公司所有。
      </Paragraph>

      <Divider />

      <div style={{ textAlign: 'center', color: '#666' }}>
        <Text>
          如有疑问，请联系我们：support@manage.net.cn
        </Text>
      </div>
    </Card>
  </div>
);

export default Terms;
